/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  CustomDomainMcpEndpoint,
  CustomDomainMcpEndpoint$inboundSchema,
} from "./customdomainmcpendpoint.js";

/**
 * Result of listing the MCP endpoints registered under an organization's custom domain.
 */
export type ListCustomDomainMcpEndpointsResult = {
  mcpEndpoints: Array<CustomDomainMcpEndpoint>;
};

/** @internal */
export const ListCustomDomainMcpEndpointsResult$inboundSchema: z.ZodMiniType<
  ListCustomDomainMcpEndpointsResult,
  unknown
> = z.pipe(
  z.object({
    mcp_endpoints: z.array(CustomDomainMcpEndpoint$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "mcp_endpoints": "mcpEndpoints",
    });
  }),
);

export function listCustomDomainMcpEndpointsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListCustomDomainMcpEndpointsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      ListCustomDomainMcpEndpointsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListCustomDomainMcpEndpointsResult' from JSON`,
  );
}
